import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { AuthService } from '../../infrastructure/auth/auth.service'
import { JamarLogoComponent } from '../components/jamar-logo'
import { IndicadorVersionComponent } from '../components/indicador-version'

export interface Totales {
  proveedores: number
  productos: number
  telas: number
  sinPrecio: number
}

/** Sidebar del tablero con totales, navegacion y cierre de sesion. */
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, JamarLogoComponent, IndicadorVersionComponent],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class SidebarComponent {
  private readonly auth = inject(AuthService)
  readonly perfil = this.auth.perfil

  @Input({ required: true }) totales!: Totales
  @Input() colapsado = false
  /** Solo se usa en movil (boton "X" + fondo oscuro, ver dashboard.html/.scss). */
  @Output() cerrar = new EventEmitter<void>()

  cerrarSesion(): void {
    void this.auth.cerrarSesion()
  }
}
